import React from 'react';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Heading, NavLayout } from '../../components';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useCommonStyles } from '../../css';
import { useStyles } from './style';
import width from './General/General';
import { useHistory } from 'react-router-dom';

const DownloadTemplate = (props: {
  imageSrc: any;
  title: string;
  to: string;
  cta: string;
  children: any;
  topLeftImage?: { src: string; left: string; top: string; width: string };
  bottomRightImage: { src: string; right: string; top: string; width: string };
}) => {
  const { t } = useTranslation('documentation');
  const commonClasses = useCommonStyles();
  const classes = useStyles();

  var history = useHistory();

  return (
    <NavLayout disableContentContainer>
      <div className="flex flex-col mx-10 md:mx-0">
        <p className="mx-auto font-roboto font-bold text-3xl mt-14 text-center mb-10 md:mb-0">
          <span className="text-green">{t('download')}</span> QuickCells
        </p>
        <div className="flex flex-row mx-auto">
          <p className="font-roboto font-bold text-xl text-center">
            {t('an')}
            <span className="ml-1 font-roboto font-bold text-green text-xl">
              {' '}
              {t('integration')}{' '}
            </span>
            <span className="ml-1 font-roboto font-bold text-black text-xl">
              {' '}
              {t('simple')}
            </span>
          </p>
        </div>
        <button
          className="bg-green rounded-full mx-auto p-4 mt-8 w-64"
          onClick={() => {
            history.push('/contact');
          }}>
          <p className="text-white font-roboto font-bold text-xl">
            {t('contact')}{' '}
          </p>
        </button>
      </div>

      {props.children}
    </NavLayout>
  );
};

export { DownloadTemplate as default, DownloadTemplate };
